import React, { useState, useEffect } from 'react';
import type { ChangeEvent } from 'react';

import { SearchIcon } from '@vlabs/icons';
import type { InputProps } from '@vlabs/uikit/components/controls/input/Input';
import { Input } from '@vlabs/uikit/components/controls/input/Input';

import { useFilterRoleTranslation } from './i18n';
import { useRoleListFilters } from './useRoleListFilters';

function FilterRoleByNameInput(props: InputProps): React.JSX.Element {
  const { t } = useFilterRoleTranslation();
  const { filters, updateFiltersDebounced } = useRoleListFilters();
  const filterName = filters.name ?? '';
  const [name, setName] = useState(filterName);

  useEffect(() => {
    setName(filterName);
  }, [filterName]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const nextName = e.target.value;
    setName(nextName);
    updateFiltersDebounced({
      name: nextName || undefined,
      page: 1,
    });
  };

  return (
    <Input
      icon={<SearchIcon />}
      onChange={handleChange}
      placeholder={t('input.placeholder')}
      value={name}
      {...props}
    />
  );
}

export { FilterRoleByNameInput };
